import styled from 'styled-components'
import DoneIcon from '@mui/icons-material/Done'
import { DarkGreen } from 'src/assets/colors'

export const PageBreak = styled.div`
  @media all {
    display: none;
  }
  @media print {
    html,
    body {
      height: initial !important;
      overflow: initial !important;
      -webkit-print-color-adjust: exact;
    }
  }
  @media print {
    margin-top: 1rem;
    display: block;
    page-break-before: always;
  }
  @page {
    size: auto;
    margin: 30mm;
  }
`
export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: .5rem 0;
`
const baseColStyles = `
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  height: 2.4rem;
`
export const Col = styled.div`
  ${baseColStyles}
  justify-content: start;
  width: 31.66%;
`
export const ColQty = styled.div`
  ${baseColStyles}
  justify-content: center;
  width: 31.66%;
`
export const ColBtn = styled.div`
  ${baseColStyles}
  justify-content: flex-end;
  width: 31.66%;
`
export const ColIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 5%;
`
export const StyledDoneIcon = styled(DoneIcon)`
  color: ${DarkGreen};
`
